
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifting/terms",
      function () {
        return require("private-next-pages/gifting/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifting/terms"])
      });
    }
  